import { Cluster } from '@core/models';
import { IUserPermission } from '@core/models/user-permission.model';
import { User } from '@core/models/user.model';

/**
 * Centralized mock data to allow running the application without a live backend.
 * These values mimic the minimum shape returned by the real APIs so the UI can render.
 */
export const MOCK_CLUSTER_LIST: Cluster[] = [
  {
    id: 1,
    selected: true,
    name: 'Mock Cluster',
    adminUrl: 'https://mock-admin.zuumapp.com',
    carbonFootprintApiUrl: 'https://mock-carbon.zuumapp.com',
    carrierTMSUrl: 'https://mock-carrier-tms.zuumapp.com',
    carrierUrl: 'https://mock-carrier.zuumapp.com',
    coreApiUrl: 'https://mock-core-api.zuumapp.com',
    esApiUrl: 'https://mock-es-api.zuumapp.com',
    mailApiUrl: 'https://mock-mail.zuumapp.com',
    pricingApiUrl: 'https://mock-pricing.zuumapp.com',
    ratingApiUrl: 'https://mock-rating.zuumapp.com',
    reportingApiUrl: 'https://mock-reporting.zuumapp.com',
    rfpApiUrl: 'https://mock-rfp.zuumapp.com',
    shipperTMSUrl: 'https://mock-shipper-tms.zuumapp.com',
    shipperUrl: 'https://mock-shipper.zuumapp.com',
    storageApiUrl: 'https://mock-storage.zuumapp.com',
    taskApiUrl: 'https://mock-task.zuumapp.com',
    trackingApiUrl: 'https://mock-tracking.zuumapp.com',
    redisName: 'mock-redis',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const MOCK_PERMISSION_OBJ: IUserPermission = {
  brokerUserPermissions: [],
  shipperUserPermissions: [],
  carrierUserPermissions: [],
  additionals: [],
};

const now = new Date().toISOString();

const mockClient: any = {
  id: 1,
  companyId: 'mock-company',
  mongoId: 'mock-mongo-id',
  accountManagerMongoId: 'mock-account-manager',
  stripeCustomerId: 'cus_mock',
  usersCount: 5,
  active: true,
  apiKey: 'mock-api-key',
  addons: [],
  branding: {},
  company: 'Mock Logistics',
  companyLogo: '',
  contactName: 'Mock Contact',
  contacts: [],
  createdAt: now,
  updatedAt: now,
  invitationSentAt: now,
  activatedAt: now,
  firstInvoiceDate: now,
  phoneNumber: '555-0100',
  type: 'DEV',
  tenantType: 'BROKER',
  env: 'dev',
  authorizedAdminId: 'mock-admin',
  contactPhone: '555-0100',
  contactSMS: '555-0100',
  contactEmail: 'contact@mocklogistics.com',
  legalCompanyName: 'Mock Logistics LLC',
  termsUrl: 'https://mock-logistics.com/terms',
  privacyUrl: 'https://mock-logistics.com/privacy',
  plans: [],
  termsAndConditionsBody: 'Mock terms and conditions',
  street: '123 Mock Street',
  suite: 'Suite 100',
  city: 'Mock City',
  settingsConfiguration: [],
  state: 'CA',
  subdomains: [],
  zip: '90001',
  status: 'Active',
  companyType: 'broker',
  hasTmsPlan: true,
  mcNumber: 'MC123456',
  dotNumber: 'DOT654321',
  federalTaxId: '12-3456789',
  esData: { _id: 'mock-es-id', _source: {} },
  autoPay: false,
  cluster: MOCK_CLUSTER_LIST[0],
  cancelDate: '',
  cancelationReason: '',
  cancelationUserId: '',
  testAccount: false,
};

export const MOCK_CLIENT = mockClient;

export const MOCK_AUTH_USER: User & { company: { tenantId: number; type: string } } = {
  id: 1,
  userId: 'mock-user-id',
  clientId: MOCK_CLIENT.id,
  client: MOCK_CLIENT,
  tenantId: 'MOCK',
  companyMcNumber: 'MC123456',
  createdAt: now,
  updatedAt: now,
  firstName: 'Mock',
  lastName: 'Admin',
  email: 'designer@zuumapp.com',
  phone: '555-0199',
  type: 'super_admin_manager',
  paidUser: true,
  isDeleted: false,
  pendingSetup: false,
  company: {
    tenantId: 1001,
    type: 'broker',
  },
};

export const MOCK_AUTH_PAYLOAD = {
  token: 'mock-super-admin-token',
  user: MOCK_AUTH_USER,
  permissionObj: MOCK_PERMISSION_OBJ,
};

export const MOCK_CORE_TOKEN_PAYLOAD = {
  token: 'mock-core-token',
};
